
























import { Product } from '@/api';
import { Component, Prop, ProvideReactive, Vue } from 'vue-property-decorator';
import { BillingSetupService } from './service/billing-setup-service';
import DirectTierSelection from './direct-tier-selection.vue';
import BillingPartnerSelection from './billing-partner-selection.vue';
import PartnerContributionSelection from './partner-contribution-selection.vue';
import Toast from '../display/toast.vue';
import SaveCancelButtons from '@/components/elements/buttons/save-cancel-buttons.vue';

@Component({
	components: {
		SaveCancelButtons,
		BillingPartnerSelection,
		PartnerContributionSelection,
		DirectTierSelection,
		Toast,
	},
})
export default class BillingSetupForm extends Vue {
	@Prop(Object)
	private readonly product!: Product & { subscriptionitem: { plan: string } };

	@ProvideReactive('billingSetupService') service = new BillingSetupService(this.product);

	public async created(): Promise<void> {
		await this.service.initialise();
	}

	public async handleSubmit(): Promise<void> {
		if (this.service.billing === null) {
			return;
		}
		const submitSucceeded: boolean = await this.service.submit(this.service.billing);
		this.handleSubmitResult(submitSucceeded);
	}

	private handleSubmitResult(submitSucceeded: boolean): void {
		if (submitSucceeded) {
			this.$bvModal.hide('edit-billing-modal');
			this.$emit('setupComplete');
			new Toast().makeToast(
				'Ordway is updating in the background, please refresh (press F5) soon.',
				'Billing updated',
				'success',
			);
		} else {
			new Toast().makeToast(
				'There was a problem updating billing, please let the software team know',
				'Error',
				'danger',
			);
		}
	}

	private dismiss(): void {
		this.$bvModal.hide('edit-billing-modal');
	}
}
